export const business = {

  keyword: {
    list: '关键字列表',
    from: '关键字操作',

    create: '添加关键字',
    view: '查看关键字',

    title: '关键字标题',
    total: '搜索次数',

    rules: {
      title: {
        require: '关键字标题不能为空',
      },
    },
  },

  // 分类
  category: {
    list: '分类列表',
    from: '分类操作',

    title: '分类名称',

    rules: {
      title: {
        require: '分类名称不能为空',
      },
    },
  },

  label: {
    list: '标签列表',
    from: '标签操作',

    title: '标签名称',

    rules: {
      title: {
        require: '标签名称不能为空',
      },
    },
  },

  // 常见问题
  problem: {
    list: '常见问题列表',
    from: '常见问题操作',
    create: '添加常见问题',
    view: '查看常见问题',

    category_id: '常见问题分类',
    title: '常见问题标题',
    content: '常见问题答案',

    rules: {
      category_id: {
        require: '常见问题分类不能为空',
      },
      title: {
        require: '常见问题标题不能为空',
      },
      content: {
        require: '常见问题答案不能为空',
      },
    },
  },

  complain: {
    list: '投诉列表',
    view: '查看投诉',
    read: '标记阅读',

    type: '投诉类型',
    category_id: '投诉分类',
    content: '投诉内容',
    nickname: '投诉人昵称',
    mobile: '投诉人电话',
    email: '投诉人邮箱',
    read_status: '阅读状态',
    create_time: '投诉时间',

    // 投诉分类
    category: {
      list: '投诉分类列表',
      from: '投诉分类操作',
      title: '投诉分类标题',

      rules: {
        title: {
          require: '投诉分类标题不能为空',
        },
      },
    },
  },

  // 签到
  sign: {
    list: '签到列表',
    from: '签到操作',

    title: '签到标题',
    days: '签到天数',
    money: '签到奖励',
    remark: '备注',

    rules: {
      title: {
        require: '签到标题不能为空',
      },
      days: {
        require: '签到天数不能为空',
      },
      money: {
        require: '签到奖励不能为空',
      },
    },
  },

  official: {
    archive: {
      list: '公众号档案列表',
      from: '公众号档案操作',
      view: '公众号档案详情',
      info: '公众号档案信息',

      category_id: '公众号档案分类',
      label_id: '公众号档案标签',
      member_id: '发布会员',
      official_account_id: '公众号ID',
      official_account_name: '公众号名称',
      description: '公众号概述',
      follow_reply: '关注回复内容',
      follow_money: '关注奖励',
      follow_total: '可关注次数',
      followed_total: '已关注次数',

      rules: {
        official_account_id: {
          require: '公众号ID不能为空',
        },
        official_account_name: {
          require: '公众号名称不能为空',
        },
        description: {
          require: '公众号概述不能为空',
        },
        follow_reply: {
          require: '公众号名称不能为空',
        },
        follow_money: {
          require: '关注奖励不能为空',
        },
        follow_total: {
          require: '可关注次数不能为空',
        },
      },

      // 公众号文章标签
      label: {
        list: '标签列表',
        from: '标签操作',

        title: '标签名称',

        rules: {
          title: {
            require: '标签名称不能为空',
          },
        },
      },

      follow: {
        follow_reply: '关注回复内容',
        is_report: '举报状态',

        create_time: '阅读时间',
      }
    },

    article: {
      list: '公众号文章列表',
      from: '公众号文章操作',
      view: '公众号文章详情',
      info: '公众号文章信息',

      category_id: '公众号文章分类',
      label_id: '公众号文章标签',
      member_id: '发布会员',
      title: '公众号文章名称',
      description: '公众号文章描述',
      link: '访问地址',
      official_account_name: '公众号名称',
      money: '阅读奖励',
      visit_total: '允许访问次数',
      browse_total: '浏览次数',
      create_time: '立项时间',

      rules: {
        title: {
          require: '公众号文章名称不能为空',
        },
        official_account_name: {
          require: '公众号名称不能为空',
        },
        money: {
          require: '阅读奖励不能为空',
        },
        visit_total: {
          require: '允许访问次数不能为空',
        },
      },

      // 公众号文章标签
      label: {
        list: '标签列表',
        from: '标签操作',

        title: '标签名称',

        rules: {
          title: {
            require: '标签名称不能为空',
          },
        },
      },

      browse: {

        browse_total: '原文阅读次数',
        url: '原文截图',
        is_report: '举报状态',

        create_time: '阅读时间',
      }
    },
  },

  statistical: {
    online_info: '在线会员',
    nickname: '会员姓名',
    create_time: '登录时间',
  }
}
